import ShareTickButton from '../ShareTickbutton';
import { Window_FillRateFallback } from './Window_FillRateFallback';
import LevelEconomyTracker from '../GameTracking/LevelEconomyTracker';
import OMT_UI_SquareButton, { BUTTONCOLOURS } from '../../OMT_UI/OMT_UI_SquareButton';
import { Window } from '../../00_IMMEDIATE/Window';
import { LevelType } from '../GameState/Managers/GameEnums';

/* eslint-disable object-shorthand */
/* eslint-disable no-use-before-define */
/* eslint-disable no-param-reassign */
/* eslint-disable func-names */

export class Window_Win extends Window {
  /**
   * The window that appears when the player beats a level.
   * @param {Object} parent
   * @param {Object} config
   * @memberof Window_Win
   */
  constructor(parent, config) {
    super(parent);
    this.state = game.state.getCurrentState();

    // imports
    const { TreasureHuntWindowPanel } = G.TreasureHunt;
    const { lvlIndex } = config;
    const { points } = config;
    const { globalScoreChange } = config;
    // config.mysteryGiftStreakIncrease is increased right before being sent to the window.
    this.increasedStreak = config.mysteryGiftStreakIncrease;

    // the amt of gems collected in the treasure hunt
    this.treasureHuntCollectedGems = config.treasureHunt ? config.treasureHunt.collectedGems : 0;

    console.log('Lvl finished', lvlIndex + 1, points);
    sdkHandler.trigger('levelFinish', {
      level: lvlIndex + 1,
      score: points,
      state: 'win',
    }, this);

    // commented because these were not being used anywhere
    // this._shareTimedOut = false;
    // this._shareComplete = false;

    // if the level is displayed as a hard level
    const hardLevel = G.lvlData && G.lvlData.showAsHard;

    // if we're in a daily challenge, we want to switch to that kind of window.
    if (this.state.mode === LevelType.CHALLENGE) {
      this.winChallenge(config);
      return;
    }

    // the last level passed before we passed this one
    const lastPassedLevelPre = G.saveState.getLastPassedLevelNr();

    // if we forced a life loss at the beginning of the level, we add that back here.
    if (this.state._removedLifeAtStart) {
      G.saveState.addLife(1, false, true);
    }

    // if this level doesnt have result data set, set it here.
    if (!G.lvl.resultData) {
      G.lvl.oldStars = G.saveState.getStars(lvlIndex);
      G.lvl.resultData = G.saveState.passLevel(lvlIndex, Math.max(1, G.lvl.stars), points, true);
    }

    // save the result
    this.result = G.lvl.resultData;

    // grabbin data from the level
    const starsAchieved = this.result.stars;
    this.oldStars = G.lvl.oldStars;


    if (this.oldStars === 0) {
      // send automated message on close if in friend context
      // OMT.social.sendClosedHelpRequest(() => {});
    }

    // if we got three stars for the first time, count that as a win
    if (this.oldStars < 3 && this.result.stars === 3) {
      if (G.winsInRow === undefined) { G.winsInRow = 0; }
      if (lastPassedLevelPre >= G.featureUnlock.unlockLevels.achievementGifts && G.featureUnlock.achievementGifts) {
        G.winsInRow++;
      }
      G.saveState.incrementCWinCount();
    }

    // if we're not a daily challenge, track the stars in the level economy tracker
    // (the finishLevel function doesn't actually do anything right now)
    if (this.state.mode !== LevelType.CHALLENGE) {
      LevelEconomyTracker.getInstance().finishLevel(starsAchieved);
    }

    // setting up layout

    this.addBackground('popup_background_2');

    this.banner = G.makeImage(
      0, -295,
      G.lvlData && G.lvlData.showAsHard ? 'purple_banner' : 'blue_banner',
      0.5, this,
    );

    this.levelTxt = new G.Text(0, -297, `${OMT.language.getText('Level')} ${lvlIndex + 1}`, {
      style: 'font-white',
      fontSize: '46px',
    }, 0.5, 330);
    this.add(this.levelTxt);

    if (hardLevel) {
      // this.hardIcon = G.makeImage(0, -350, 'map_point_hard', 0.5, this);
      // this.hardIcon.scale.setTo(0.75);
      this.levelTxt.position.y = -310;
      this.hardWarningTxt = new G.Text(0, -275, OMT.language.getText('Hard Level'), {
        style: 'font-white',
        fontSize: '20px',
      }, 0.5);
      this.add(this.hardWarningTxt);
    }

    this.youWinTxt = new G.Text(0, -70, OMT.language.getText('You win!'), {
      style: G.OMTsettings.global.hawaiiMatch ? 'font-white' : 'font-purple',
      fontSize: '45px',
    }, 0.5, 530);
    this.add(this.youWinTxt);

    this.scoreBg = G.makeImage(20, 20, 'popup_text_backgr', 0.5, this);
    this.scoreIcon = G.makeImage(-90, 18, 'score_icon', 0.5, this);
    this.scoreIcon.scale.setTo(1);

    // if we're getting coins as a reward, display them
    if (G.lvl.resultData.reward > 0) {
      G.saveState.changeCoins(G.lvl.resultData.reward);

      this.coinBg = G.makeImage(20, 120, 'popup_text_backgr', 0.5, this);
      this.coinIco = G.makeImage(-90, 120, 'coin_1', 0.5, this);

      this.amountTxt = new G.TextCounter(25, 120, 0, {
        style: 'font-purple',
        fontSize: '45px',
      }, 0.5, 160);
      this.add(this.amountTxt);

      this.addDoubleRewardBtn(150, 120, this.amountTxt, this.result.reward);
    }

    this.scoreTxt = new G.Text(32, 20, points.toString(), {
      style: 'font-purple',
      fontSize: '45px',
    }, 0.5, 190);
    this.add(this.scoreTxt);

    // setting up buttons

    const onRetryClick = () => {
      /* G.sb("onAllWindowsClosed").add(function() {
        G.sb("onStateChange").dispatch('Game',G.lvlNr);
      }) */
      G.sb('pushWindow').dispatch('level');
      this.closeWindow();
    };
    this.retryBtn = new OMT_UI_SquareButton(-120, 240, {
      button: {
        tint: BUTTONCOLOURS.orange,
        dimensions: {
          width: 196,
          height: 100,
        },
        extraDetail: false,
      },
      text: {
        string: OMT.language.getText('Retry'),
        textStyle: {
          style: 'font-white',
          fontSize: 40,
          lineSpacing: -8,
        },
        dimensionMods: {
          height: 1.1,
        },
      },
      options: {
        clickFunction: {
          onClick: onRetryClick.bind(this),
        },
      },
    });
    this.registerButtons(this.retryBtn);

    const onContClick = () => {
      this.handleClose(lvlIndex, globalScoreChange);
    };
    this.continueBtn = new OMT_UI_SquareButton(120, 240, {
      button: {
        tint: BUTTONCOLOURS.green,
        dimensions: {
          width: 196,
          height: 100,
        },
      },
      text: {
        string: OMT.language.getText('Continue'),
        textStyle: {
          style: 'font-white',
          fontSize: 40,
        },
        dimensionMods: {
          height: 1.1,
        },
      },
      options: {
        clickFunction: {
          onClick: onContClick.bind(this),
          disableAfterClick: true,
        },
      },
    });
    this.registerButtons(this.continueBtn);
    this.continueBtn.visible = false;
    var that = this;
    sdkHandler.trigger('beforePlayButtonDisplay', {
      callback: () => {
        that.continueBtn.visible = true;
      }
    }, this);

    // if it's a hard level, give the player the option to share their victory.
    if (hardLevel) {
      // show share
      if (DDNA.tracking.enabled) DDNA.tracking.getDataCapture().setPlayerCharacterizationParam('seenHardLevelShareBtn', 1);
      this.retryBtn.y = 205;
      this.retryBtn.scale.setTo(0.95, 0.95);
      this.continueBtn.y = 205;
      this.continueBtn.scale.setTo(0.95, 0.95);
      // this.shareUI = this.add(new ShareTickButton(0, 250, {
      //   style: 'font-white',
      //   fontSize: 36,
      //   lineSpacing: -10,
      // }, true));
      // this.shareUI.signals.onClick.addOnce(() => {
      //   G.GiftUI.HelperFunctions.showShareLoadingOverlay(this);

      //   let closed = false;

      //   const timeout = G.AsyncUtils.createScheduler(game);
      //   timeout.rescheduleAction(() => {
      //     closed = true;
      //     this.handleClose(lvlIndex, globalScoreChange);
      //   }, 5000);

      //   OMT.social.shareHardLevelCompleteMsg(lvlIndex + 1, () => {
      //     DDNA.tracking.getDataCapture().setPlayerCharacterizationParam('usedHardLevelShareBtn', 1);
      //     if (closed) return;
      //     timeout.cancelSchedule();
      //     this.handleClose(lvlIndex, globalScoreChange);
      //   });
      // });
    }

    // make blank stars
    this.blankStars = [
      G.makeImage(-100, -150, 'star_blank', 0.5, this),
      G.makeImage(0, -175, 'star_blank', 0.5, this),
      G.makeImage(100, -150, 'star_blank', 0.5, this),
    ];
    this.blankStars[0].scale.setTo(0.8);
    this.blankStars[2].scale.setTo(0.8);

    // replace blank stars with full stars based on how many stars the player achieved.
    this.stars = [
      G.makeImage(-100, -150, starsAchieved >= 1 ? 'star' : 'star_blank', 0.5, this),
      G.makeImage(0, -175, starsAchieved >= 2 ? 'star' : 'star_blank', 0.5, this),
      G.makeImage(100, -150, starsAchieved >= 3 ? 'star' : 'star_blank', 0.5, this),
    ];
    this.stars[0].scale.setTo(0.8);
    this.stars[2].scale.setTo(0.8);

    // bring in the stars
    this.stars.forEach(function (elem, index) {
      if (index + 1 <= starsAchieved) {
        const orgScale = elem.scale.x;
        elem.scale.setTo(0);
        const tween = game.add.tween(elem.scale).to({ x: orgScale, y: orgScale }, 300, Phaser.Easing.Bounce.Out, true, 800 + (index * 200));
        tween.onStart.add(function () {
          G.sfx.pop.play();
          G.sfx.explosion_subtle.play();
          this.add(new G.WinStarPart(elem.x, elem.y, true));
          this.add(new G.WinStarPart(elem.x, elem.y, true));
          this.add(new G.WinStarPart(elem.x, elem.y, true));
          this.add(new G.WinStarPart(elem.x, elem.y, true));
          this.add(new G.WinStarPart(elem.x, elem.y, true));
        }, this);
      } else {
        elem.visible = false;
      }
    }, this);

    // DDNA.transactionHelper.queueLevelCoinReward(result.reward, 'LevelEnd');
    // DDNA.transactionHelper.sendQueuedLevelCoinRewards();

    game.time.events.add(1000, function () {
      if (this.result.reward > 0) {
        this.amountTxt.increaseAmount(this.result.reward);
      }
    }, this);

    G.sb('onLevelMoneyGain').dispatch(this.result.reward);


    // check if it is first time level 0
    // hide retry btn
    if (lastPassedLevelPre === 0 || G.lvl.stars === 3) {
      this.retryBtn.visible = false;
      this.continueBtn.x = 0;
      this.continueBtn.pulse(1.05);
    }

    // if we're in the treasure hunt, adapt
    if (config.treasureHunt) {
      adaptToTreasureHunt.bind(this)();
    }

    // change banner and add panel
    function adaptToTreasureHunt() {
      this.banner.changeTexture('Treasure_Hunt_header');
      this.TreasureHuntWindowPanel = this.add(new TreasureHuntWindowPanel({
        tutorial: true,
        collectedGems: this.treasureHuntCollectedGems,
      }));
      this.y = -100;
      this.TreasureHuntWindowPanel.y = 395;
    }

    // G.Window.prototype.win_showScorePanel = function(perLevelPassResp){
    //   if(this.state.highscorePanel){
    //     this.state.highscorePanel.visible = true;
    //     return;
    //   }

    //   if (perLevelPassResp && perLevelPassResp.leaderboard) {
    //     this.state.highscorePanel = new G.HighscorePanelIngame();
    //     this.state.highscorePanel.injectLevelData(perLevelPassResp.leaderboard, perLevelPassResp.passed);
    //     this.state.highscorePanel.makeVisible();
    //   }
    // }
  }

  /**
   * Hide the score panel.
   *
   * @memberof Window_Win
   */
  hideScorePanel() {
    if (this.state.highscorePanel) {
      this.state.highscorePanel.visible = false;
    }
  }

  /**
   * When an ad was successfully completed.
   *
   * @param {Object} btn The btn that triggered this ad, so we can disable it.
   * @param {Object} counter The coin counter.
   * @param {number} amount The amount of coins we should increase the counter by..
   * @memberof Window_Win
   */
  adSuccess(btn, counter, amount) {
    // track the reward
    DDNA.transactionHelper.trackRewards(['coin', amount], [], {
      transactionType: 'AD',
      tActionType: 'AD',
      tGameArea: 'LEVEL',
      tAdCoins: amount,
      tAdValue: amount,
      tAdRewardType: 'DOUBLE_VALUE',
    });

    // log the ad watch
    OMT.platformTracking.logEvent(OMT.platformTracking.Events.WatchAdToDoubleCoinsOnLevelComplete);

    // add the amount to the money gained of this level
    G.lvl.moneyGained += amount;
    counter.increaseAmount(amount);
    G.saveState.changeCoins(amount, false);

    // disable the ad button so they can watch an ad multiple times.
    btn.inputEnabled = false;

    // hide the button.
    game.add.tween(btn)
      .to({ alpha: 0 }, 300, Phaser.Easing.Sinusoidal.In, true);
  }

  /**
   * Add the 'double reward' button to the window.
   *
   * @param {number} x The x position of the button.
   * @param {number} y The y position of the button.
   * @param {number} counter The coin counter.
   * @param {number} amount The amount of coins to add to the counter.
   * @returns The 'double reward' button.
   * @memberof Window_Win
   */
  addDoubleRewardBtn(x, y, counter, amount) {
    const onClick = () => {
      sdkHandler.trigger('rewardedAd', {
        callback: (success) => {
          if (success) { this.adSuccess(btn, counter, amount); }
          else {
            new Window_FillRateFallback(undefined, {
              placement: G.BuildEnvironment.adPlacements.doubleLevelCoins,
              callback: () => {
                this.adSuccess(btn, counter, amount);
              },
              context: this,
            });
          }
        }
      }, this);
      // OMT.ads.showAd(
      //   G.BuildEnvironment.adPlacements.doubleLevelCoins,
      //   // on ad success
      //   () => {
      //     this.adSuccess(btn, counter, amount);
      //   },
      //   // on ad failure
      //   () => {
      //     if (!G.IAP) { // no IAPS dont use ad fallbacks
      //       // eslint-disable-next-line no-new
      //       new Window_FillRateFallback(undefined, {
      //         placement: G.BuildEnvironment.adPlacements.doubleLevelCoins,
      //         callback: function () {
      //           this.adSuccess(btn, counter, amount);
      //         },
      //         context: this,
      //       });
      //     } else { // open ad fallback
      //       OMT.ads.showAdFallback(this.adSuccess.bind(this, btn, counter, amount));
      //     }
      //   },
      // );
    };
    // create the image for the button
    const img = G.makeImage(35, 0, 'btn-movie-icon', 0.5, null);
    img.scale.set(0.75);

    // create the button itself
    const btn = new OMT_UI_SquareButton(x, y, {
      button: {
        tint: BUTTONCOLOURS.purple,
        dimensions: {
          width: 150,
          height: 75,
        },
        extraDetail: false,
      },
      text: {
        string: 'x2',
        textStyle: { style: 'font-white', fontSize: 56 },
        icon: {
          image: img,
          offset: {
            x: (img.width / 2) + 10,
          },
          align: 'left',
        },
        offset: {
          x: -img.width + 10,
        },
      },
      options: {
        clickFunction: {
          onClick: onClick.bind(this),
        },
      },
    });

    this.registerButtons(btn);
    return btn;
  }

  /**
   * Close the window and return to the map scene with any rewards.
   *
   * @param {number} lvlIndex The index of the level we just beat.
   * @param {number} globalScoreChange The change in the global score.
   * @memberof Window_Win
   */
  handleClose(lvlIndex, globalScoreChange) {
    // track the completion of the first level
    if (lvlIndex === 0) {
      DDNA.tracking.ftuxEvent(6, 'firstLevelEndContinue');
    }

    G.sb('onAllWindowsClosed').add(() => {
      // grab the boosters the player had available for this level
      const level_assembleBoosters = (nextLevel) => { // Same function from window_level
        let reqHelpBooster = [];
        if (this._requestHelp_inventory) {
          reqHelpBooster = this._requestHelp_inventory.getInventory();
        }
        const startBoosters = {
          player: this.state.startBoosterConfig.getConfigForLevel(nextLevel),
          requestHelp: reqHelpBooster,
        };
        return startBoosters;
      };
      // if we're in the first few levels, don't go to saga map, just jump to next level
      if (OMT.feature.getUseNewFTUX() && (G.saveState.getLastPassedLevelNr()) < G.OMTsettings.FTUXSettings.runLevelsUpTo) {
        const nextLevel = G.saveState.getLastPassedLevelNr();
        const levelData = {
          lvlIndex: nextLevel,
          debugMode: G.debugMode === true,
          startBoosters: level_assembleBoosters(nextLevel),
          challengeLvl: null,
          preLevelTrackingData: { requestHelp: {} },
        };
        // we update coins if we are not going back to the map
        G.sb('onCoinsChange').dispatch(G.saveState.getCoins());
        G.sb('onStateChange').dispatch('Game', levelData);
        // otherwise, check for ads and go back to the map.
      } else {
        sdkHandler.trigger('playButtonPressed', {
          callback: () => {
            G.sb('onStateChange').dispatch(G.debugMode ? 'EditorWorld' : 'World', {
              lvlNr: lvlIndex,
              reward: G.lvl.moneyGained,
              starImprovement: G.lvl.resultData.starImprovement,
              mysteryGiftStreakIncrease: this.increasedStreak,
              treasureHuntCollectedGems: this.treasureHuntCollectedGems,
              globalScoreChange,
            });
          }
        }, this);
        // this.state.endPointCheckForAds(() => {
        //   G.sb('onStateChange').dispatch(G.debugMode ? 'EditorWorld' : 'World', {
        //     lvlNr: lvlIndex,
        //     reward: G.lvl.moneyGained,
        //     starImprovement: G.lvl.resultData.starImprovement,
        //     mysteryGiftStreakIncrease: this.increasedStreak,
        //     treasureHuntCollectedGems: this.treasureHuntCollectedGems,
        //     globalScoreChange,
        //   });
        // });
      }
    }, this);

    // if achievement gifts are unlocked and we've won three levels in a row, pop up the gifts
    if (G.featureUnlock.achievementGifts && lvlIndex >= G.featureUnlock.unlockLevels.achievementGifts && G.winsInRow >= 3) {
      G.winsInRow = 0;
      G.sb('pushWindow').dispatch(['gift', {
        reason: G.GiftUI.Constants.GiftReasons.Achievement,
        placement: G.BuildEnvironment.adPlacements.achievementGift,
        monetiseType: game.incentivised() ? G.GiftUI.Constants.MonetiseOptions.OpenOtherGifts : false,
        showGingy: false,
        showTitleBar: true,
        shareable: false,
        incentivisedSharing: false,
        giftBoxType: G.GiftUI.Constants.GiftBoxTypes.Retro,
        twoFrameOpen: G.OMTsettings.elements.gifts.twoFrameOpen,
        adTracking: {
          requestEvent: 'VideoAdWatchAccomplish',
        },
        resourceTracking: {
          itemType: 'Reward',
          itemId: 'Achievement',
        },
        onOpen: () => {
          this.hideScorePanel();
        },
        offset: {
          x: 0,
          y: -90,
        },
        gingyOffset: {
          x: 0,
          y: -160,
        },
        gingyTitleOffset: {
          x: 0,
          y: -240,
        },
        giftOffset: {
          x: 0,
          y: 30,
        },
        gifts: getGifts(),
        lvlIndex: lvlIndex,
      }]);
    }

    this.closeWindow();

    function getGifts() {
      if (G.IAP) {
        return [
          G.gift.getGift('WinningStreak_Gift'),
          G.gift.getGift('WinningStreak_Gift'),
          G.gift.getGift('WinningStreak_Gift'),
        ];
      }
      return [
        G.gift.getGift(Math.random() < 0.5 ? 'normalsGingyGift_boosters_achievement' : 'normalsGingyGift_coins_achievement', true),
        G.gift.getGift(Math.random() < 0.5 ? 'normalsGingyGift_boosters_achievement' : 'normalsGingyGift_coins_achievement', true),
        G.gift.getGift(Math.random() < 0.5 ? 'normalsGingyGift_boosters_achievement' : 'normalsGingyGift_coins_achievement', true),
      ];
    }
  }

  /**
   * Change how the window is displayed, if the level is a challenge level.
   *
   * @param {Object} config The config for the new window display
   * @memberof Window_Win
   */
  winChallenge(config) {
    const { globalScoreChange } = config;
    const starsAchieved = G.lvl.stars;
    const difference = Math.max(starsAchieved - G.saveState.getChallengeStars(), 0);

    const coinReward = G.saveState.computeDailyChallengeReward();
    console.log(`G.lvl.stars: ${G.lvl.stars}`);
    console.log(`G.saveState.getChallengeStars: ${G.saveState.getChallengeStars()}`);
    // changing state

    G.saveState.markChallengeCompleted();
    G.saveState.passExtraLevel(difference);
    G.saveState.accumulateChallengeStars(difference);

    // setting up layout
    this.addBackground('popup_background_2');
    this.banner = G.makeImage(0, -295, 'orange_banner', 0.5, this);

    // for the header txt
    this.levelTxt = new G.Text(0, -297, OMT.language.getText('Daily Challenge'), {
      style: 'font-white',
      fontSize: '60px',
    }, 0.5, 260);
    this.add(this.levelTxt);

    this.youWinTxt = new G.Text(0, -70, OMT.language.getText('You win!'), {
      style: 'font-purple',
      fontSize: '45px',
    }, 0.5, 530);
    this.add(this.youWinTxt);

    this.scoreBg = G.makeImage(20, 20, 'popup_text_backgr', 0.5, this);
    this.scoreIcon = G.makeImage(-90, 20, 'score_icon', 0.5, this);
    this.scoreIcon.scale.setTo(1.2);

    if (coinReward > 0) {
      // displaying how many coins the player received
      this.coinBg = G.makeImage(20, 120, 'popup_text_backgr', 0.5, this);
      this.coinIco = G.makeImage(-90, 120, 'coin_1', 0.5, this);
      this.amountTxt = new G.TextCounter(25, 120, 0, {
        style: 'font-purple',
        fontSize: '45px',
      }, 0.5, 160);
      this.add(this.amountTxt);
      G.saveState.changeCoins(coinReward, false);
    }

    // setting up the slots for the stars to potentially fill
    this.blankStars = [
      G.makeImage(-100, -150, 'star_blank', 0.5, this),
      G.makeImage(0, -175, 'star_blank', 0.5, this),
      G.makeImage(100, -150, 'star_blank', 0.5, this),
    ];
    this.blankStars[0].scale.setTo(0.8);
    this.blankStars[2].scale.setTo(0.8);

    // displaying how many stars the player achieved in the level.
    this.stars = [
      G.makeImage(-100, -150, starsAchieved >= 1 ? 'star' : 'star_blank', 0.5, this),
      G.makeImage(0, -175, starsAchieved >= 2 ? 'star' : 'star_blank', 0.5, this),
      G.makeImage(100, -150, starsAchieved >= 3 ? 'star' : 'star_blank', 0.5, this),
    ];
    this.stars[0].scale.setTo(0.8);
    this.stars[2].scale.setTo(0.8);

    // tween in the stars
    this.stars.forEach((elem, index) => {
      if (index + 1 <= starsAchieved) {
        const orgScale = elem.scale.x;
        elem.scale.setTo(0);
        const tween = game.add.tween(elem.scale).to({ x: orgScale, y: orgScale }, 300, Phaser.Easing.Bounce.Out, true, 800 + (index * 200));
        tween.onStart.add(() => {
          G.sfx.pop.play();
          G.sfx.explosion_subtle.play();
          this.add(new G.WinStarPart(elem.x, elem.y, true));
          this.add(new G.WinStarPart(elem.x, elem.y, true));
          this.add(new G.WinStarPart(elem.x, elem.y, true));
          this.add(new G.WinStarPart(elem.x, elem.y, true));
          this.add(new G.WinStarPart(elem.x, elem.y, true));
        }, this);
      } else {
        elem.visible = false;
      }
    }, this);

    // display the score the player got
    this.scoreTxt = new G.Text(32, 20, G.lvl.points.toString(), {
      style: 'font-purple',
      fontSize: '45px',
    }, 0.5, 190);
    this.add(this.scoreTxt);

    // setting up button

    const onContinueClick = () => {
      var that = this;
      sdkHandler.trigger('playButtonPressed', {
        callback: () => {
          // switch back to map, and let map know to give reward
          console.log("calllback");
          G.sb('onStateChange').dispatch(G.debugMode ? 'EditorWorld' : 'World', {
            lvlNr: G.lvl.levelIndex,
            reward: G.lvl.moneyGained,
            // star: coinReward,
            starImprovement: difference,
            challenge: true,
            globalScoreChange,
          });
        }
      }, this);
      // game.state.getCurrentState().endPointCheckForAds(() => {
      //   G.sb('onAllWindowsClosed').add(() => {
      //     // switch back to map, and let map know to give reward
      //     G.sb('onStateChange').dispatch(G.debugMode ? 'EditorWorld' : 'World', {
      //       lvlNr: G.lvl.levelIndex,
      //       reward: G.lvl.moneyGained,
      //       // star: coinReward,
      //       starImprovement: difference,
      //       challenge: true,
      //       globalScoreChange,
      //     });
      //   });
      //   this.closeWindow();
      // });
    };

    this.continueBtn = new OMT_UI_SquareButton(0, 240, {
      button: {
        tint: BUTTONCOLOURS.green,
        dimensions: {
          width: 196,
          height: 100,
        },
      },
      text: {
        string: OMT.language.getText('Continue'),
        textStyle: { style: 'font-white', fontSize: 70 },
      },
      options: {
        clickFunction: {
          onClick: onContinueClick.bind(this),
        },
      },
    });

    this.registerButtons(this.continueBtn);
    this.continueBtn.visible = false;
    var that = this;
    sdkHandler.trigger('beforePlayButtonDisplay', {
      callback: () => {
        that.continueBtn.visible = true;
      }
    }, this);

    /* NOTE: These need to be sent later (in SaveState.passLevel) in order for the tracking to function correctly
    *        Specifically, event need to occur in this order or else the reward amounts are zeroed before they are sent to DDNA:
    *
    *        DDNA.transactionHelper.queueLevelCoinReward(result.reward, 'LevelEnd');
    *        G.sb('onLevelFinished').dispatch(levelIndex, newStars, newPoints);
    *        DDNA.transactionHelper.sendQueuedLevelCoinRewards();
    * */

    // DDNA.transactionHelper.queueLevelCoinReward(coinReward, 'LevelEnd');
    // DDNA.transactionHelper.sendQueuedLevelCoinRewards();

    // setting up signals

    G.sb('onDailyChallengeFinished').dispatch();
    G.sb('onDailyChallengeWon').dispatch();

    game.time.events.add(1000, () => {
      if (coinReward > 0) {
        G.sb('onLevelMoneyGain').dispatch(coinReward);
        this.amountTxt.increaseAmount(coinReward);
      }
    }, this);
  }

  // G.Window.prototype.win_showScorePanel = function(perLevelPassResp){
  //   if(this.state.highscorePanel){
  //     this.state.highscorePanel.visible = true;
  //     return;
  //   }

  //   if (perLevelPassResp && perLevelPassResp.leaderboard) {
  //     this.state.highscorePanel = new G.HighscorePanelIngame();
  //     this.state.highscorePanel.injectLevelData(perLevelPassResp.leaderboard, perLevelPassResp.passed);
  //     this.state.highscorePanel.makeVisible();
  //   }
  // }
}
// create global references
if (!window.Windows) window.Windows = {};
Windows.win = Window_Win;
